module.exports = __webpack_public_path__ + "img/printer-label-brother2.5eff5e3b.jpg";